<ng-template
  let-extraClass="extraClass"
  #topNav
>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [title]="pageTitle"
    [backButton]="true">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>
    <ng-container *ngIf="loaded">
      <ng-container *ngIf="!confirmingPlanCoop">

        <tidy-row [align]="'center'">
          <tidy-text
            *ngIf="cleaning?.type === 'cleaning' && !cleaning?.standby"
            [body]="'This Client needs you for their cleaning.'">
          </tidy-text>
          <tidy-text
            *ngIf="cleaning?.type === 'plan' && !cleaning?.standby"
            [body]="'This Client needs you for their recurring cleaning.'">
          </tidy-text>
          <tidy-text
            *ngIf="cleaning?.standby"
            body="This is a <u>standby opportunity</u>, which means there is about a 50% chance you will be needed. Assume the job will happen and go to it. You will receive the Booking Protection Minimum Payment">
          </tidy-text>
          <tidy-text
            *ngIf="cleaning?.standby"
            [body]="'(+' +
            (cleaning?.booking_protection_minimum_payment | tcurrency)">
          </tidy-text>
          <tidy-text
            *ngIf="') if you are not needed. '">
          </tidy-text>
          <tidy-text
            *ngIf="cleaning?.standby"
            (action)="openStandbyLearnMore()"
            body="Learn More"
            class="link">
          </tidy-text>
        </tidy-row>

        <tidy-card>
          <tidy-row>
            <tidy-text
              [header]="cleaning.customer_first_name"
              [translate]="false">
            </tidy-text>
            <tidy-image
              *ngIf="cleaning?.is_private || cleaning?.is_repeat"
              [src]="'assets/img/star.svg'"
              class="header-size"
              style="margin-left:5px">
            </tidy-image>
          </tidy-row>
          <tidy-row *ngIf="jobTimeItems?.length == 1">
            <tidy-text
              [body]="'Starts '">
            </tidy-text>
            <tidy-text
              [body]="(cleaning?.time | ttime)">
            </tidy-text>
            <tidy-text
              [body]="' on '">
            </tidy-text>
            <tidy-text
              [body]="(cleaning?.date | formatDateTimePipe: 'LLL d')">
            </tidy-text>
          </tidy-row>
          <ng-container *ngIf="cleaning?.address && cleaning?.is_private">
            <tidy-row>
              <tidy-text
                [body]="cleaning?.service_type_details?.customer_name || cleaning?.service_type_details?.name">
              </tidy-text>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Blocking '">
              </tidy-text>
              <tidy-text
                [body]="(cleaning?.service_type_details?.duration_in_minutes / 60)">
              </tidy-text>
              <tidy-text
                [body]="' hour' + ((cleaning?.service_type_details?.duration_in_minutes / 60) == 1 ? '' : 's') + ' on calendar'">
              </tidy-text>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="cleaning?.address?.address1 + (cleaning?.address?.address2 ? (' ' + cleaning?.address?.address2) : '') + (cleaning?.address_name ? (' - ' + cleaning?.address_name) : '')"
                [translate]="false">
              </tidy-text>
            </tidy-row>
          </ng-container>
          <tidy-row *ngIf="cleaning?.address | tidyPropertyDetails as propertyDetails">
            <tidy-text [body]="propertyDetails"></tidy-text>
          </tidy-row>
          <tidy-row *ngIf="!(cleaning?.address && cleaning?.is_private)">
            <ng-container *ngIf="cleaning?.service_type_details?.name && cleaning?.service_type_details?.key && !cleaning?.service_type_details?.key?.includes('cleaning')">
              <tidy-text
                [body]="cleaning?.service_type_details?.name">
              </tidy-text>
            </ng-container>
            <ng-container *ngIf="cleaning?.service_type_details?.key && cleaning.service_type_details.key.includes('cleaning')">
              <tidy-text
                [body]="parseServiceLength(cleaning.service_type) | titlecase">
              </tidy-text>
              <tidy-text
                [body]="' Regular Cleaning '">
              </tidy-text>
            </ng-container>
          </tidy-row>
          <tidy-row>
            <payment-tag
              [billingType]="cleaning.billing_type"
              [totalValue]="cleaning.cleaning_amount"
              [bonusValue]="cleaning.bonus_amount">
            </payment-tag>
            <tidy-text
              *ngIf="cleaning?.is_private"
              [body]="'* '">
            </tidy-text>
            <tidy-text
              *ngIf="cleaning?.pay_rate_origin == 'job_amount_percentage'"
              [body]="'* '">
            </tidy-text>
            <tidy-text
              *ngIf="cleaning.type == 'plan'"
              [body]="' / ' + (cleaning?.frequency | planFrequency)"
              style="margin-right:10px; margin-left: 5px">
            </tidy-text>
          </tidy-row>
          <tidy-row *ngIf="(cleaning?.homekeeper_preferences?.gender == 'female' ||  cleaning?.homekeeper_preferences?.gender == 'male') && hasTeamMembers">
            <tidy-text
              [body]="cleaning?.homekeeper_preferences?.gender == 'female' ? 'Females Only' : 'Males Only'">
            </tidy-text>
          </tidy-row>
          <tidy-row *ngIf="!(cleaning?.address && cleaning?.is_private)">
            <tidy-text
              [body]="'Zip: '">
            </tidy-text>
            <tidy-text
              [body]="cleaning?.zipcode">
            </tidy-text>
          </tidy-row>

          <tidy-row *ngIf="cleaning?.pay_rate_origin == 'job_amount_percentage'">
            <tidy-text
              [body]="'*Lower your public rates to allow clients to automatically book you at these rates in the future.'">
            </tidy-text>
          </tidy-row>

          <tidy-row *ngIf="cleaning?.is_private">
            <tidy-text
              [body]="'*This is a private job so you can edit the price after accepting.'">
            </tidy-text>
          </tidy-row>

          <tidy-row *ngIf="checkShouldShowBigSpender(cleaning)">
            <tidy-text
              [actionBody]="'Big Spender: They book many jobs.'"
              class="green">
            </tidy-text>
          </tidy-row>

          <ng-container *ngIf="jobTimeItems?.length > 1">
            <tidy-row class="extra-top-padding extra-bottom-padding">
              <tidy-divider></tidy-divider>
            </tidy-row>

            <form [formGroup]="form">
              <tidy-row>
                <tidy-select
                  [label]="'Select which start time you want:'"
                  [items]="jobTimeItems"
                  [form]="form.controls.jobTime"
                  formControlName="jobTime">
                </tidy-select>
              </tidy-row>
            </form>
          </ng-container>

          <tidy-row *ngIf="cleaning?.standby" class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/people-outline.svg'"
              class="body-size">
            </tidy-image>
            <tidy-text
              [body]="'Standby'">
            </tidy-text>
          </tidy-row>
        </tidy-card>

        <tidy-card *ngIf="bookingFormAnswers?.length > 0">
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/information.svg'"
              class="title-size">
            </tidy-image>
            <tidy-text
              [title]="'Job Note'">
            </tidy-text>
          </tidy-row>
          <ng-container *ngFor="let answer of bookingFormAnswers">
            <ng-container *ngIf="answer?.template_input?.type == 'text' || answer?.template_input?.type == 'text_area'">
              <tidy-row>
                <tidy-text
                  [body]="answer?.template_input?.label + ': ' + answer?.data?.value">
                </tidy-text>
              </tidy-row>
              <tidy-photo-note
                *ngIf="answer?.template_input?.image_url"
                [src]="answer?.template_input?.image_url">
              </tidy-photo-note>
            </ng-container>
            <ng-container *ngIf="answer?.template_input?.type == 'select'">
              <tidy-row>
                <tidy-text
                  [body]="answer?.template_input?.label + ': ' + me.getBookingFormSelectValue(answer?.data?.value)">
                </tidy-text>
              </tidy-row>
              <tidy-photo-note
                *ngIf="answer?.template_input?.image_url"
                [src]="answer?.template_input?.image_url">
              </tidy-photo-note>
            </ng-container>
            <ng-container *ngIf="answer?.template_input?.type == 'multiselect'">
              <tidy-row>
                <tidy-text
                  [body]="answer?.template_input?.label + ': ' + me.getBookingFormMultiselectValue(answer?.data?.value)">
                </tidy-text>
              </tidy-row>
              <tidy-photo-note
                *ngIf="answer?.template_input?.image_url"
                [src]="answer?.template_input?.image_url">
              </tidy-photo-note>
            </ng-container>
            <ng-container *ngIf="answer?.template_input?.type == 'file' && answer?.template_input?.data?.type == 'image'">
              <tidy-row>
                <tidy-text
                  [body]="answer?.template_input?.label">
                </tidy-text>
              </tidy-row>
              <tidy-carrousel
                class="photo-notes-carrousel only-padding-bottom"
                [scaleImages]="true">
                <tidy-photo-note
                  *tidyCarrousel
                  [src]="answer?.data?.value">
                </tidy-photo-note>
              </tidy-carrousel>
            </ng-container>
            <ng-container *ngIf="answer?.template_input?.type == 'files'  && answer?.template_input?.data?.type == 'images'">
              <tidy-row>
                <tidy-text
                  [body]="answer?.template_input?.label">
                </tidy-text>
              </tidy-row>
              <tidy-carrousel
                class="photo-notes-carrousel only-padding-bottom"
                [scaleImages]="true">
                <ng-container *ngFor="let imageUrl of answer?.data?.value">
                  <tidy-photo-note
                    *tidyCarrousel
                    [src]="imageUrl">
                  </tidy-photo-note>
                </ng-container>
              </tidy-carrousel>
            </ng-container>
          </ng-container>
        </tidy-card>

        <tidy-alert *ngIf="jobsFromClientCount > 1">
          <tidy-text
            [body]="cleaning?.customer_first_name"
            [translate]="false">
          </tidy-text>
          <tidy-text
            [body]="' also requested '">
          </tidy-text>
          <tidy-text
            [body]="(jobsFromClientCount - 1)">
          </tidy-text>
          <tidy-text
            [body]="' other jobs. '">
          </tidy-text>
          <tidy-text
            (action)="openOtherOptionsPage()"
            [body]="'View'"
            class="link">
          </tidy-text>
        </tidy-alert>

        <tidy-row class="extra-bottom-padding">
          <div [attr.id]="mapUid" style="width: 100%; height: 300px; border-radius: 8px;">
          </div>
        </tidy-row>

        <tidy-alert *ngIf="didGoLive">
          <tidy-row style="margin-top: -5px">
            <tidy-checkbox
              [(checked)]="bookingProtection"
              [items]="[
                {
                  viewValue: 'Booking Protection', value: true
                }
              ]"
              [initValue]="bookingProtection">
            </tidy-checkbox>
          </tidy-row>

          <tidy-row>
            <tidy-text
              [body]="'If Client cancels, find me a new Client during this time or earn '">
            </tidy-text>
            <tidy-text
              [body]="(cleaning?.booking_protection_minimum_payment | tcurrency) +
              '. '">
            </tidy-text>
            <tidy-text
              (action)="openBookingProtectionLearnMore()"
              [body]="'Learn More'"
              class="link">
            </tidy-text>
          </tidy-row>
        </tidy-alert>

        <!-- Credentials Needed Inline Forms -->
        <ng-container *ngIf="inlineCredentialFields?.length > 0">
          <tidy-card>
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/shield-checkmark-outline.svg'"
                class="header-size">
              </tidy-image>
              <tidy-text
                [header]="'Credentials Needed'">
              </tidy-text>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'The client requires that you add these credentials to accept this job.'">
              </tidy-text>
            </tidy-row>
            <form [formGroup]="credentialForm">
              <ng-container *ngFor="let field of inlineCredentialFields">

                <!-- URL inputs -->
                <tidy-row class="extra-top-padding" *ngIf="field.inputType === 'url'">
                  <tidy-input
                    [formControlName]="field.key"
                    [label]="field.label"
                    [form]="credentialForm.controls[field.key]"
                    [icon]="'assets/svg/globe-outline.svg'"
                    [activeIcon]="'assets/svg/globe-outline.svg'"
                    [errorMessage]="'This field is required.'"
                    [submitted]="field.showError"
                    [placeholder]="field.placeholder">
                  </tidy-input>
                </tidy-row>

                <!-- Textarea inputs -->
                <ng-container *ngIf="field.inputType === 'textarea'">
                  <tidy-row class="extra-top-padding">
                    <tidy-textarea
                      [formControlName]="field.key"
                      [label]="field.label"
                      [form]="credentialForm.controls[field.key]"
                      [icon]="'assets/svg/text.svg'"
                      [activeIcon]="'assets/svg/text-tidy-green.svg'">
                    </tidy-textarea>
                  </tidy-row>
                  <tidy-error-message
                    *ngIf="field.showError && !credentialForm.controls[field.key]?.value"
                    [text]="'This field is required.'">
                  </tidy-error-message>
                </ng-container>

                <!-- Number inputs -->
                <tidy-row class="extra-top-padding" *ngIf="field.inputType === 'number'">
                  <tidy-input
                    [formControlName]="field.key"
                    [label]="field.label"
                    [form]="credentialForm.controls[field.key]"
                    [type]="'number'"
                    [inputMode]="'numeric'"
                    [icon]="'assets/svg/text.svg'"
                    [activeIcon]="'assets/svg/text-tidy-green.svg'"
                    [errorMessage]="'This field is required.'"
                    [submitted]="field.showError">
                  </tidy-input>
                </tidy-row>

                <!-- Toggle inputs -->
                <tidy-row class="extra-top-padding vertical-align-center" *ngIf="field.inputType === 'toggle'">
                  <tidy-text [body]="field.label" [translate]="false"></tidy-text>
                  <tidy-toggle
                    [toggled]="field.toggleValue"
                    (toggleChanged)="onInlineToggleChange(field, $event)"
                    style="margin-left: 12px;">
                  </tidy-toggle>
                </tidy-row>

                <!-- File: Image upload (profile_image) -->
                <ng-container *ngIf="field.inputType === 'file' && field.isProfileImage">
                  <tidy-row class="extra-top-padding">
                    <tidy-text [body]="field.label" [translate]="false"></tidy-text>
                  </tidy-row>
                  <tidy-row>
                    <tidy-file-upload
                      [accept]="'image/*'"
                      [multiple]="false"
                      [label]="'Upload Photo'"
                      [images]="field.uploadedImages"
                      [showPreview]="true"
                      [showDeleteButton]="true"
                      [showDownloadButton]="false"
                      (addedImagesChange)="onInlineFileAdded(field, $event)"
                      (removedImageChange)="onInlineFileRemoved(field)"
                      (onError)="onInlineFileError(field, $event)">
                    </tidy-file-upload>
                  </tidy-row>
                  <tidy-row *ngIf="field.isUploading">
                    <tidy-text [helper]="'Uploading...'"></tidy-text>
                  </tidy-row>
                  <tidy-error-message
                    *ngIf="field.showError && !field.uploadedFileUrl"
                    [text]="'Please upload a photo.'">
                  </tidy-error-message>
                </ng-container>

                <!-- File: Generic (certifications, documents) -->
                <ng-container *ngIf="field.inputType === 'file' && !field.isProfileImage">
                  <tidy-row class="extra-top-padding">
                    <tidy-text [body]="field.label" [translate]="false"></tidy-text>
                  </tidy-row>
                  <ng-container *ngIf="field.uploadedFileName">
                    <tidy-two-column-row style="margin-top: 6px;">
                      <tidy-text [body]="field.uploadedFileName" [translate]="false"></tidy-text>
                      <tidy-text
                        [actionBody]="'remove'"
                        (action)="onInlineFileRemoved(field)"
                        class="link red">
                      </tidy-text>
                    </tidy-two-column-row>
                  </ng-container>
                  <ng-container *ngIf="!field.uploadedFileName">
                    <div style="margin-top: 6px;">
                      <tidy-button
                        [text]="'Upload File'"
                        [action]="pickInlineFile.bind(this, field)"
                        class="secondary">
                      </tidy-button>
                    </div>
                  </ng-container>
                  <tidy-row *ngIf="field.isUploading">
                    <tidy-text [helper]="'Uploading file...'"></tidy-text>
                  </tidy-row>
                  <tidy-error-message
                    *ngIf="field.showError && !field.uploadedFileUrl"
                    [text]="'Please upload a file.'">
                  </tidy-error-message>
                </ng-container>

              </ng-container>
            </form>
          </tidy-card>
        </ng-container>

        <!-- Preferred Credentials Section -->
        <ng-container *ngIf="preferredCredentials?.length > 0">
          <tidy-card>
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/star-outline.svg'"
                class="header-size">
              </tidy-image>
              <tidy-text
                [header]="'Preferred Credentials'">
              </tidy-text>
            </tidy-row>
            <ng-container *ngFor="let cred of preferredCredentials">
              <tidy-row
                class="vertical-align-center credential-row credential-preferred"
                [ngClass]="{'credential-row-tappable': !cred.requirement_satisfied}"
                (click)="!cred.requirement_satisfied ? navigateToAddCredential(cred.key) : null">
                <tidy-image
                  *ngIf="cred.requirement_satisfied"
                  [src]="'assets/svg/checkmark-circle.svg'"
                  class="body-size credential-icon-met">
                </tidy-image>
                <tidy-image
                  *ngIf="!cred.requirement_satisfied"
                  [src]="'assets/svg/information-circle-outline.svg'"
                  class="body-size credential-icon-preferred">
                </tidy-image>
                <tidy-text
                  [body]="cred.label"
                  [translate]="false">
                </tidy-text>
                <tidy-text
                  *ngIf="!cred.requirement_satisfied"
                  [body]="'Recommended'"
                  class="credential-recommended-text">
                </tidy-text>
                <tidy-image
                  *ngIf="!cred.requirement_satisfied"
                  [src]="'assets/svg/chevron-forward-outline.svg'"
                  class="body-size"
                  style="margin-left: auto;">
                </tidy-image>
              </tidy-row>
              <tidy-row *ngIf="!cred.requirement_satisfied && justSubmittedCredential" style="margin-left: 28px;">
                <tidy-text
                  [helper]="'Pending review'"
                  class="credential-pending">
                </tidy-text>
              </tidy-row>
            </ng-container>
          </tidy-card>
        </ng-container>

        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'Please take '">
          </tidy-text>
          <countdown
            (onTimeout)="enableClaimButton()"
            [target]="countdownTarget">
          </countdown>
          <tidy-text
            [body]="' to review.'">
          </tidy-text>
        </tidy-row>

        <tidy-error-message
          [text]="apiError">
        </tidy-error-message>

        <ng-container *ngIf="cleaning?.type === 'cleaning'">
          <ng-container>
            <ion-row>
              <div style="width: 100%;">
                <tidy-button
                  [disabled]="claimButtonDisabled"
                  [text]="'Add Job'"
                  [action]="claimCleaning.bind(this)"
                  class="primary">
                </tidy-button>
              </div>
            </ion-row>
            <ion-row *ngIf="cleaning?.allow_decline">
              <div style="width: 100%;">
                <tidy-button
                  [disabled]="claimButtonDisabled"
                  [text]="'Decline Request'"
                  [action]="showConfirmDeclineCleaningAlert.bind(this)"
                  class="secondary">
                </tidy-button>
              </div>
            </ion-row>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="cleaning?.type === 'plan'">
          <ng-container>
            <ion-row>
              <div style="width: 100%;">
                <tidy-button
                  [disabled]="claimButtonDisabled"
                  [text]="'Add Plan'"
                  [action]="confirmPlanCoop.bind(this)"
                  class="primary">
                </tidy-button>
              </div>
            </ion-row>
            <ion-row *ngIf="cleaning?.allow_decline">
              <div style="width: 100%;">
                <tidy-button
                  [disabled]="claimButtonDisabled"
                  [text]="'Decline Request'"
                  [action]="showConfirmDeclineCleaningAlert.bind(this)"
                  class="secondary">
                </tidy-button>
              </div>
            </ion-row>
          </ng-container>

          <tidy-row [align]="'center'">
            <tidy-text
              *ngIf="cleaning?.bonus_amount === 0"
              [body]="(cleaning?.date | formatDateTimePipe:'EEEE') +
              's ' +
              (cleaning?.time | ttime) +
              ' - ' +
              (cleaningEndTime | ttime) +
              '.'">
            </tidy-text>
            <tidy-text
              *ngIf="cleaning?.bonus_amount === 0"
              [body]="'Makes you bookable '">
            </tidy-text>
            <tidy-text
              *ngIf="cleaning?.bonus_amount > 0"
              [body]="'Keep this time bookable 4 weeks to keep the bonus. $'">
            </tidy-text>
            <tidy-text
              *ngIf="cleaning?.bonus_amount > 0"
              [body]="(cleaning?.bonus_amount | tcurrency)">
            </tidy-text>
            <tidy-text
              *ngIf="cleaning?.bonus_amount > 0"
              [body]="' bonus paid with first job only.'">
            </tidy-text>
          </tidy-row>
        </ng-container>

        <!-- Price Later Form -->
        <ng-container>
          <tidy-divider style="margin-top: 10px;"></tidy-divider>
          <tidy-row *ngIf="getAllQuotesForJob()">
            <tidy-alert class="info-quote-alert" style="padding: 8px 10px;">
              <tidy-row class="vertical-align-center" [alignLastItemRight]="true">
                <tidy-image
                  [src]="'assets/svg/information-circle-outline.svg'"
                  class="body-size"
                  style="margin-right: 8px;">
                </tidy-image>
                <tidy-text [body]="formatQuoteIndicator(getAllQuotesForJob())" [translate]="false" style="font-weight: 600;"></tidy-text>
                <tidy-text
                  [body]="'Cancel Quote'"
                  (action)="showConfirmCancelQuoteAlert()"
                  class="link red">
                </tidy-text>
              </tidy-row>
            </tidy-alert>
          </tidy-row>
          <tidy-card>
            <tidy-row class="extra-bottom-padding vertical-align-center">
              <tidy-image [src]="'assets/svg/cash-outline.svg'"> </tidy-image>
              <tidy-text [header]="'Send Quote'"> </tidy-text>
            </tidy-row>
            <form [formGroup]="priceLaterForm">
              <tidy-row class="field-top-padding field-bottom-padding">
                <tidy-input
                  formControlName="amount"
                  inputMode="numeric"
                  [label]="'Amount'"
                  [form]="priceLaterForm.controls.amount"
                  [icon]="'assets/svg/cash.svg'"
                  [activeIcon]="'assets/svg/cash-tidy-green.svg'"
                  [mask]="'currencyMask'"
                  [type]="'text'"
                  [submitted]="submitted"
                  [errorMessage]="'Please enter the estimated amount.'">
                </tidy-input>
              </tidy-row>
              <tidy-row class="field-bottom-padding">
                <tidy-textarea
                  [label]="'Notes'"
                  formControlName="notes"
                  [form]="priceLaterForm.controls.notes"
                  [icon]="'assets/svg/information-circle-outline.svg'">
                </tidy-textarea>
              </tidy-row>
            </form>
            <tidy-row class="field-top-padding field-bottom-padding">
              <tidy-text [body]="'Select the days / times to send a quote for this job:'"></tidy-text>
            </tidy-row>
            <ng-container *ngFor="let day of quoteDaysAndTimes; let dayIndex = index">
              <tidy-card class="quote-day-card">
                <tidy-row class="vertical-align-center quote-day-header" style="cursor: pointer; padding: 4px 0;" (click)="toggleDaySelection(dayIndex, $event)">
                  <tidy-checkbox
                    class="date-checkbox"
                    [items]="[{viewValue: '', value: true}]"
                    [initValue]="day.selected">
                  </tidy-checkbox>
                  <tidy-text [header]="day.dateLabel" [translate]="false" style="margin-left: 8px;"></tidy-text>
                </tidy-row>
                <ng-container *ngIf="day.selected && day.times.length > 0">
                  <tidy-row *ngFor="let time of day.times; let i = index">
                    <tidy-three-column-row *ngIf="i % 3 === 0">
                      <div class="time-checkbox-container">
                        <tidy-checkbox
                          class="time-checkbox"
                          [items]="[{viewValue: time.timeLabel, value: true}]"
                          [initValue]="time.selected"
                          (checkedChange)="onTimeCheckboxChange(dayIndex, i, $event)">
                        </tidy-checkbox>
                      </div>
                      <div class="time-checkbox-container" *ngIf="day.times[i+1]">
                        <tidy-checkbox
                          class="time-checkbox"
                          [items]="[{viewValue: day.times[i+1].timeLabel, value: true}]"
                          [initValue]="day.times[i+1].selected"
                          (checkedChange)="onTimeCheckboxChange(dayIndex, i+1, $event)">
                        </tidy-checkbox>
                      </div>
                      <div class="time-checkbox-container" *ngIf="day.times[i+2]">
                        <tidy-checkbox
                          class="time-checkbox"
                          [items]="[{viewValue: day.times[i+2].timeLabel, value: true}]"
                          [initValue]="day.times[i+2].selected"
                          (checkedChange)="onTimeCheckboxChange(dayIndex, i+2, $event)">
                        </tidy-checkbox>
                      </div>
                    </tidy-three-column-row>
                  </tidy-row>
                </ng-container>
              </tidy-card>
            </ng-container>
            <ion-row>
              <div style="width: 100%">
                <tidy-button
                  [disabled]="claimButtonDisabled"
                  [text]="!cleaning?.vendor_outreach_request_quote ? 'Send Quote' : 'Update Quote'"
                  [action]="submitQuoteRequest.bind(this)"
                  class="secondary">
                </tidy-button>
              </div>
            </ion-row>
          </tidy-card>

          <tidy-error-message [text]="apiError"> </tidy-error-message>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="confirmingPlanCoop">
        <tidy-row [align]="'center'" *ngIf="cleaning.bonus_amount <= 0">
          <tidy-text
            [body]="'Claiming this opportunity will make you bookable '">
          </tidy-text>
          <tidy-text
            [body]="(cleaning?.date | formatDateTimePipe:'EEEE') + 's'">
          </tidy-text>
          <tidy-text
            [body]="' from '">
          </tidy-text>
          <tidy-text
            [body]="(cleaning?.time | ttime)">
          </tidy-text>
          <tidy-text
            [body]="' to '">
          </tidy-text>
          <tidy-text
            [body]="(cleaningEndTime | ttime) + '. '">
          </tidy-text>
          <tidy-text
            (action)="openBonusLearnMore()"
            [body]="'Learn More'"
            class="link">
          </tidy-text>
        </tidy-row>

        <ng-container *ngIf="cleaning.bonus_amount > 0">
          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'You will be paid the '">
            </tidy-text>
            <tidy-text
              [body]="(cleaning?.bonus_amount | tcurrency)">
            </tidy-text>
            <tidy-text
              [body]="'bonus if you complete the '">
            </tidy-text>
            <tidy-text
              [body]="(cleaning?.date | formatDateTimePipe: 'EEEE LLL d')">
            </tidy-text>
            <tidy-text
              [body]="' cleaning or the Client cancels after 8pm the night before.'">
            </tidy-text>
          </tidy-row>

          <tidy-row [align]="'center'">
            <tidy-text
              [body]="'To keep this bonus you must <b>remain bookable</b> from '">
            </tidy-text>
            <tidy-text
              [body]="(cleaning?.time | ttime)">
            </tidy-text>
            <tidy-text
              [body]="' to '">
            </tidy-text>
            <tidy-text
              [body]="(cleaningEndTime | ttime)">
            </tidy-text>
            <tidy-text
              [body]="' on:'">
            </tidy-text>
          </tidy-row>

          <tidy-row *ngFor="let date of planDates" [align]="'center'">
            <tidy-text
              [body]="(date | formatDateTimePipe: 'EEEE LLL d')">
            </tidy-text>
          </tidy-row>

          <tidy-row class="extra-bottom-padding" [align]="'center'">
            <tidy-text
              [body]="'You will lose the bonus if you are unbookable for this time on any of those days. '">
            </tidy-text>
            <tidy-text
              (action)="openBonusLearnMore()"
              [body]="'Learn More'"
              class="link">
            </tidy-text>
          </tidy-row>
        </ng-container>

        <tidy-error-message
          [text]="apiError">
        </tidy-error-message>

        <ion-row>
          <div style="width: 100%;">
            <tidy-button
              [disabled]="claimButtonDisabled"
              [action]="claimCleaning.bind(this)"
              [text]="'Confirm'"
              class="primary">
            </tidy-button>
          </div>
        </ion-row>
        <ion-row *ngIf="cleaning?.allow_decline">
          <div style="width: 100%;">
            <tidy-button
              [disabled]="claimButtonDisabled"
              [text]="'Decline Request'"
              [action]="showConfirmDeclineCleaningAlert.bind(this)"
              class="secondary">
            </tidy-button>
          </div>
        </ion-row>

      </ng-container>

      <div style="height: 7rem;"></div>
    </ng-container>
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
